// Map of DB column / legacy friendly names to Title Case labels used in
// "Profile Updated (…)" entries throughout the app.
export const CLIENT_FIELD_LABELS: Record<string, string> = {
  first_name: 'Name',
  last_name: 'Name',
  name: 'Name',
  phone: 'Phone Number',
  email: 'Email',
  address: 'Address',
  photo_url: 'Photo',
  photo: 'Photo',
  allergies: 'Allergies',
  site_id: 'Facility',
  site: 'Facility',
  room_id: 'Room',
  room: 'Room',
  gender: 'Gender',
  date_of_birth: 'Date of Birth',
  age: 'Date of Birth',
  emergency_contact_name: 'Emergency Contact',
  emergency_contact_phone: 'Emergency Contact',
  emergency_contact_relationship: 'Emergency Contact',
  'emergency contact': 'Emergency Contact',
  case_worker_id: 'Case Manager',
  'case worker': 'Case Manager',
  is_head_of_household: 'Head of Household',
  'household status': 'Head of Household',
  children: 'Children',
  partner_id: 'Partner',
  partner_name: 'Partner',
  partner: 'Partner',
  property_storage_notes: 'Property Notes',
  'property notes': 'Property Notes',
  status: 'Status',
  check_in_time: 'Check-In Time',
  'check-in time': 'Check-In Time',
  'check-in': 'Check-In Time',
  check_out_time: 'Check-Out Time',
  'check-out time': 'Check-Out Time',
  'check-out': 'Check-Out Time',
  pass_start: 'Pass',
  pass_end: 'Pass',
  pass_type: 'Pass',
  pass: 'Pass',
  intake_date: 'Intake Date',
  archived_at: 'Archived',
  archived: 'Archived',
  
};

export function formatClientFieldList(fields: string[] | undefined | null): string[] {
  if (!fields || !Array.isArray(fields)) return [];
  const labels = fields.map((f) => CLIENT_FIELD_LABELS[f] || f);
  return [...new Set(labels)];
}
